import { createContext } from 'react';
import type { ForecastField } from '../api/forecastFieldsService';

export interface ForecastFieldsContextType {
  fields: ForecastField[];
  fieldsByDbName: Map<string, ForecastField>;
  loading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const ForecastFieldsContext = createContext<ForecastFieldsContextType | undefined>(undefined);
